// extracted by mini-css-extract-plugin
module.exports = {"upload-region":"_5e45578337e006190270421d69c4d8c2-less","uploadRegion":"_5e45578337e006190270421d69c4d8c2-less"};